import type { CultureFacilityDTO } from '@ui/shared/util-api';
import type { CultureMapItemModel } from '../entities/culture-map-item.model';
import { CultureMapFacilityItemModel } from '../entities/culture-map-facility-item.model';

export class CulturalFacilityMapper {
    public static fromDto(facility: CultureFacilityDTO): CultureMapItemModel {
        return new CultureMapFacilityItemModel({
            id: facility.id,
            uniqueId: `${ facility.id }-facility`,
            title: facility.title,
            location: facility.location,
            short_description: facility.short_description,
            iconPath: facility.icon ?? '',
            imagePath: facility.image?.thumbs?.detail ?? undefined,
            thumbnailPath: facility.image?.thumbs?.preview ?? facility.image?.thumbs?.detail ?? undefined,

            phone: facility.phone,
            email: facility.email,
            fax: facility.fax ?? undefined,
            weblink: facility.weblink ?? undefined,
        });
    }
}
